import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UpdateAdminGQL } from '@wb/core/schema/mutation-definitions/admin.graphql';
import { AuthService } from '@wb/core/services/auth.service';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.sass'],
})
export class TermsComponent implements OnDestroy, OnInit {
  fileContents: any;

  private userUid?: string;

  private destroyed$ = new Subject<void>();

  private readonly cdnUrl = `${environment.aws.cdnUri}/legal/${this.translate.currentLang}`;

  isSaving = false;

  constructor(
    private readonly router: Router,
    private readonly http: HttpClient,
    private readonly authService: AuthService,
    private readonly translate: TranslateService,
    private updateAdminGQL: UpdateAdminGQL,
    public dialogRef: MatDialogRef<TermsComponent>,
  ) {}

  ngOnInit() {
    this.http
      .get(`${this.cdnUrl}/admin_termsOfService.txt`, { responseType: 'text' })
      .pipe(take(1))
      .subscribe({
        next: (file: any) => {
          this.fileContents = file.replaceAll('\\"', '&quot');
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
        },
      });
    this.userUid = this.authService.getUserUid;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  /**
   * Sets the
   * @param agree_terms
   * @returns
   */
  async updateAgreeTerms(agreeTerms: string) {
    return new Promise((resolve, reject) => {
      if (this.userUid) {
        this.updateAdminGQL
          .mutate({ uid: this.userUid, input: { agree_terms: agreeTerms } }, { fetchPolicy: 'no-cache' })
          .pipe(
            map((result) => result.data?.updateAdmin.admin),
            takeUntil(this.destroyed$),
          )
          .subscribe({
            next: (admin) => {
              resolve(admin);
            },
            error: (err: HttpErrorResponse) => {
              console.error(err);
              reject(err);
            },
          });
      }
    });
  }

  async onSubmit() {
    this.dialogRef.close(true);
    await this.updateAgreeTerms('1');
  }

  public get file(): string {
    return this.fileContents;
  }
}
